var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarkRelevantSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h50v50H0z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "svg-path1 svg-fill-color",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke svg-stroke-color",
    strokeWidth: 0.3,
    d: "M20.994 36c2.573 0 5.12-.988 7.069-2.937 3.899-3.899 3.899-10.24 0-14.139-3.899-3.899-10.24-3.899-14.139 0-3.899 3.899-3.899 10.24 0 14.139A9.958 9.958 0 0 0 20.994 36zm-6.16-16.166a8.698 8.698 0 0 1 6.16-2.547 8.706 8.706 0 0 1 6.16 14.867 8.706 8.706 0 0 1-12.32 0 8.706 8.706 0 0 1 0-12.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg-path1",
    d: "M18.71 30c.193 0 .36-.063.498-.168l3.598-2.969c.111-.105.194-.231.194-.358v-3.979c0-.294-.304-.526-.692-.526-.388 0-.692.232-.692.526v3.79l-3.432 2.8c-.25.21-.25.547.027.737a.848.848 0 0 0 .499.147z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25 13)"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF",
    fill: "#FFF",
    cx: 7,
    cy: 7,
    r: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg-path1 svg-fill-color",
    fillRule: "nonzero",
    d: "M5.186 9.3 3.44 7.434a.81.81 0 0 0-1.178-.006.909.909 0 0 0-.008 1.247l2.077 2.23a1 1 0 0 0 1.464 0l5.944-6.392a.941.941 0 0 0 .01-1.27.772.772 0 0 0-1.15.001L5.186 9.301z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkRelevantSmall);
export default __webpack_public_path__ + "static/media/mark-relevant-small.3eea04e039b078cb28464e698cf0f203.svg";
export { ForwardRef as ReactComponent };